<template>
    <div
    id="stickybar"
    class="d-none d-sm-block wow slideInRight animated"
    data-wow-delay="2s"
  >
    <ul>
      <li>
        <a
          href="kontakt/"
          style="width: 70px; height: 70px; padding-top: 10px"
        >
          <i class="fa fa-phone fa-2x" style="font-size: 1.3em"></i>
          <span style="height: 70px; padding-top: 10px; margin-top: -10px"
            >+49 36730 30843</span
          >
        </a>
      </li>
      <li>
        <a
          :href="'mailto:' + $t('adresseMail') + '@' + $t('adresseDomain') "          
          style="width: 70px; height: 70px; padding-top: 10px"
          ><i class="far fa-envelope-open fa-2x" style="font-size: 1.3em"></i>
          <span style="height: 70px; padding-top: 10px; margin-top: -10px">
            {{ $t('adresseMail') }}@{{$t('adresseDomain')}}</span
          ></a
        >
      </li>
    </ul>
  </div>

</template>